import { render, staticRenderFns } from "./NotebookView.vue?vue&type=template&id=06c1b1f1"
import script from "./NotebookView.vue?vue&type=script&lang=js"
export * from "./NotebookView.vue?vue&type=script&lang=js"
import style0 from "./NotebookView.vue?vue&type=style&index=0&id=06c1b1f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports